<template>
  <div class="page detail page-detail detail-info">
    <div class="top" v-if="!is_app">
      <img class="logo" :src="logo" />
      <a
        class="btn"
        href="https://a.app.qq.com/o/simple.jsp?pkgname=com.redirect.wangxs.qiantu"
        >在官方APP中打开</a
      >
    </div>
    <div :class="appClass">
      <div class="title">{{ detail.mname }}</div>
      <div class="cover">
        <img class="cover-img" :src="detail.image" />
        <!-- <div class="sta sta-ing">{{ newStatus }}</div> -->
        <!-- <div class="sta sta-over" style="display: none">已截稿</div> -->
        <!-- <div class="total-num">{{ detail.total }}</div> -->
      </div>
      <div class="text" v-html="detail.requirements">
        {{ detail.requirements }}
      </div>
    </div>
    <div class="bottom">
      <a class="btn-w" href="javascript:;" @click="goOfficial(detail.url)"
        >前往官网投稿</a
      >
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "DetailInfo",
  components: {
    // Lightbox
  },
  data() {
    return {
      showPicker: false,
      logo: require("../static/images/logo.png"),
      close: require("../static/images/close-1.png"),
      // 缓存 matchList 初始化列表，用 list 筛选赋值 matchList
      id: this.$route.params.id,
      detail: {
        tg_status: 0,
        match_group: [],
        button_show: 0,
        prizes_rs: 0,
        limit_province: "",
        limit_city: "",
        requirements: "",
        image: "",
      },
      isShowContribute: false,
      status: "",
      matchType: [],
      // 截稿样式
      statusClass: "sta sta-ing",
      type: "",
      // 是否在app中打开
      is_app: false,
      appClass: "desc-main",
      // 接口事件设置状态，防止连点
      isClick: true,
    };
  },
  // computed: {
  //   newStatus: function() {
  //     // computed的属性必须是data里面显式声明的响应式属性
  //     let statusAry = {
  //       0: "即将开始",
  //       1: "征稿中",
  //       2: "已截稿",
  //     };
  //     // console.log(this.detail);
  //     return statusAry[this.detail.tg_status];
  //     // return this.detail.tg_status;
  //   },
  // },
  methods: {
    init() {
      this.tools.infoDetail_cache({ id: this.id }, true).then((res) => {
        Object.assign(this.detail, res);
        document.title = this.detail.mname;
      });
    },
    goOfficial(link) {
      window.location.href = link;
    },
  },
  created() {
    this.init();
    if (this.tools.openInWebview()) {
      this.is_app = true;
      this.appClass = "desc-main desc-app";
      // $(".desc-main").css("padding-top", 0);
    }
    // var data = { url: window.location.href, id: this.id };
    // this.tools.wx_share_init(data);
  },
  mounted() {
    // 跳转路由之前会先执行这个
  },
};
</script>

<style lang="scss">
.van-overlay {
  z-index: 9;
}
// .page-detail {
//   margin-bottom: 106px;
// }
.detail {
  .desc-main{
    min-height: 100vh;
    box-sizing: border-box;
    .text{
      padding-bottom: 120px;
    }
  }
  .more-detail {
    position: absolute;
    bottom: 0;
    width: 100%;
    a {
      border: 0;
      border-radius: 0;
      border-bottom: 1px solid #000;
      height: 100px;
      line-height: 100px;
    }
    .close-detail {
      border: 0;
      margin-top: 20px;
      color: #333;
    }
  }
}
.input-btn {
  border-bottom: 0.0005rem solid #f0f0f0;
  padding: 0 0 10px 0;
  margin-top: 10px;
}
.detail-info {
  .btn-w {
    background: #f77e5e;
    border-color: #f77e5e;
    color: #fff;
    width: 580px;
    margin: 0 auto;
  }
  .bottom{
    height: 120px;
  }
}
.ql-align-center {
  text-align: center;
}
</style>
